"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserBoxInnerGrid = exports.TeaserBoxWithoutTabs = exports.TeaserBoxVersion = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * Symbols explanation:
 *   - "XL" stands for the `<Tile>` partial with the `TileSize.XL`.
 *   - "L" stands for the `<Tile>` partial with the `TileSize.L`.
 *   - "S" stands for the `<Tile>` partial with the `TileSize.S`.
 *   - "T" stands for the `<Tile>` partial with the `TileSize.S` and `titleOnImage` prop set to `false`.
 *   - "text-list" stands for the `<TextList>` partial.
 *   - "thumbnails-list" stands for the `<ThumbnailsList>` partial.
 *   - "big-thumbnails-list" stands for the `<ThumbnailsList>` partial with bigger images.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Paweł Korzeniewski <pawel.korzeniewski@movecloser.pl>
 */
var TeaserBoxVersion;
(function (TeaserBoxVersion) {
    TeaserBoxVersion["1XL"] = "1XL";
    TeaserBoxVersion["2L"] = "2L";
    TeaserBoxVersion["8S"] = "8S";
    TeaserBoxVersion["4S"] = "4S";
    TeaserBoxVersion["8T"] = "8T";
    TeaserBoxVersion["L-2S-big-thumbnails-list"] = "L-2S-big-thumbnails-list";
    TeaserBoxVersion["L-2S-text-list"] = "L-2S-text-list";
    TeaserBoxVersion["L-2S-thumbnails-list"] = "L-2S-thumbnails-list";
    TeaserBoxVersion["L-4S"] = "L-4S";
    TeaserBoxVersion["L-8S"] = "L-8S";
    TeaserBoxVersion["L-5S-text-list"] = "L-5S-text-list";
    TeaserBoxVersion["6S-big-thumbnails-list"] = "6S-big-thumbnails-list";
    TeaserBoxVersion["6S-text-list"] = "6S-text-list";
    TeaserBoxVersion["6S-thumbnails-list"] = "6S-thumbnails-list";
    TeaserBoxVersion["6T-text-list"] = "6T-text-list";
})(TeaserBoxVersion = exports.TeaserBoxVersion || (exports.TeaserBoxVersion = {}));
exports.TeaserBoxWithoutTabs = [
    TeaserBoxVersion['L-5S-text-list']
];
/**
 * Describes the component capable of rendering the contents
 * from one, specific `TeaserBoxVersion`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class TeaserBoxInnerGrid extends vue_property_decorator_1.Vue {
}
__decorate([
    vue_property_decorator_1.Prop({
        type: Array,
        required: true
    }),
    __metadata("design:type", Array)
], TeaserBoxInnerGrid.prototype, "articles", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", String)
], TeaserBoxInnerGrid.prototype, "fallbackImage", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], TeaserBoxInnerGrid.prototype, "isLazy", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], TeaserBoxInnerGrid.prototype, "isMobile", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false
    }),
    __metadata("design:type", Object)
], TeaserBoxInnerGrid.prototype, "readMoreLink", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], TeaserBoxInnerGrid.prototype, "relatedService", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], TeaserBoxInnerGrid.prototype, "windowService", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], TeaserBoxInnerGrid.prototype, "teaserBoxConfig", void 0);
exports.TeaserBoxInnerGrid = TeaserBoxInnerGrid;
//# sourceMappingURL=TeaserBox.contracts.js.map